import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useSchemaMarkup from "./useSchemaMarkup.js";

/* ❌ Firebase imports – ABHI COMMENT / REMOVE
import { db } from "../../Contexts/Firebaseconfig.js";
import { doc, getDoc } from "firebase/firestore";
*/

// ❌ HTML strip helper – blog ke liye tha (future use)
/*
function stripHtmlTags(html) {
  let doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
}
*/

// ✅ Service Pages Data (Static)
const serviceData = {
  "drone_health_check": {
    serviceType: "Drone Health Check: Keep Your Drone Healthy",
    description:
      "At Drone Didi, we provide complete inspection of your drone, battery & power testing, drone's software updates and preventive maintenance.",
    url: "https://dronedidi.co.in/drone_health_check",
  },
  "repair_and_maintenance": {
    serviceType: "Drone Repair & Maintenance",
    description:
      "From spare parts to advanced repairs, we are here to keep your drone and your journey running smoothly, without heavy costs.",
    url: "https://dronedidi.co.in/repair_and_maintenance",
  },
  "smartfarming": {
    serviceType: "Smart Farming With Advisory & Data Insights",
    description:
      "At Drone Didi, your drone doesn’t just fly, it also collects valuable data. With our consulting and analytics services, we turn that data into simple and practical insights.",
    url: "https://dronedidi.co.in/smartfarming",
  },
  "helpdesk": {
    serviceType: "Technical Support",
    description:
      "At Drone Didi, we provide a dedicated phone and WhatsApp support helpline for quick solutions, troubleshooting guidance, software support and remote assistance.",
    url: "https://dronedidi.co.in/helpdesk",
  },
};

const SchemaInjector = () => {
  const location = useLocation();
  const [schemaType, setSchemaType] = useState(null);
  const [schemaData, setSchemaData] = useState(null);

  useEffect(() => {
    const fetchSchemaData = async () => {
      let type = null;
      let data = {};

      // ✅ HomePage Schema
      if (location.pathname === "/") {
        type = "HomePage";
      }
      // ✅ AboutPage Schema
      else if (location.pathname === "/about") {
        type = "AboutPage";
      }
      // ✅ Sustainability Page
      else if (location.pathname === "/sustainability") {
        type = "SustainabilityPage";
      }
      // ✅ ContactPage Schema
      else if (location.pathname === "/contact") {
        type = "ContactPage";
      }

      /* ❌ Blog Listing Page – FUTURE USE
      else if (location.pathname === "/blog") {
        type = "BlogPage";
        data = {
          name: "Precision Grow Blog",
          description: "Explore insightful blogs on agriculture technology and sustainability.",
          url: "https://precisiongrow.co.in/blog",
        };
      }
      */

      /* ❌ Blog Detail Page – FUTURE USE (Firebase)
      else if (location.pathname.startsWith("/post/")) {
        const blogSlug = location.pathname.replace("/post/", "");
        type = "BlogPage";

        try {
          const docRef = doc(db, "posts", blogSlug);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            data = {
              title: docSnap.data().title,
              slug: blogSlug,
              metaDescription: docSnap.data().metaDescription,
              content: stripHtmlTags(docSnap.data().content),
              imageURL: docSnap.data().imageURL,
              authorName: docSnap.data().authorName,
            };
          } else {
            setSchemaType(null);
            return;
          }
        } catch (error) {
          setSchemaType(null);
          return;
        }
      }
      */

      // ✅ Service Pages Schema
      else {
        const serviceSlug = location.pathname.replace("/", "");
        if (serviceData[serviceSlug]) {
          type = "ServicePage";
          data = serviceData[serviceSlug];
        } else {
          console.warn(`⚠️ No schema found for: ${location.pathname}`);
          setSchemaType(null);
          return;
        }
      }

      setSchemaType(type);
      setSchemaData(data);
    };

    fetchSchemaData();
  }, [location.pathname]);

  useSchemaMarkup(schemaType, schemaData);

  return null;
};

export default SchemaInjector;
